<template>
  <IQOS
    :enabled="editing"
    required
    :title="$t('settings_cafe.contacts.title')"
  >
      <div class="contact-row mt-16">
        <img src="/icons/contacts-phone.svg" alt="">
        <BaseInput
          class="ml-8"
          fullWidth
          :disabled="!editing"
          :mask="countryBasedPhoneMask"
          :placeholder="$t('settings_cafe.contacts.phone')"
          v-model="edit_fields.contact_phone"
        />
      </div>
      <div class="contact-row mt-16">
        <img src="/icons/contacts-instagram.svg" alt="">
        <BaseInput
          class="ml-8"
          fullWidth
          :disabled="!editing"
          :placeholder="$t('settings_cafe.social.instagram')"
          v-model="edit_fields.social.instagram"
        />
      </div>
      <div class="contact-row mt-16">
        <img src="/icons/contacts-facebook.svg" alt="">
        <BaseInput
          fullWidth
          class="ml-8"
          :disabled="!editing"
          :placeholder="$t('settings_cafe.social.facebook')"
          v-model="edit_fields.social.facebook"
        />
      </div>
      <!-- <div class="contact-row mt-16">
        <BaseIcon icon="phone-filled"/>
        <BaseInput
          fullWidth
          class="ml-8"
          :disabled="!editing"
          :placeholder="$t('settings_cafe.social.website')"
          v-model="edit_fields.social.website"
        />
      </div> -->

    <template #actions>
      <IQOSActions 
        v-model="editing"
        @accept="saveChanges"/>
    </template>
  </IQOS>
</template>

<script>
export default {
  data() {
    return {
      editing: false,
      edit_fields: {
        contact_phone: null,
        
        social: {
          instagram: null,
          facebook: null,
          website: null
        }
      }
    };
  },
  methods: {
    saveChanges() {
      this.$store.commit('patchCafeGeneralData', this.edit_fields);

      this.$store.dispatch("saveCafe");

      this.editing = false;

      this.$store.dispatch("auditlog/write", {
        type: "social_links",
        payload: this.edit_fields.social,
      });
    },
    reset() {
      this.edit_fields.contact_phone = this.cafe.contact_phone;
      this.edit_fields.social.instagram = this.cafe.social.instagram;
      this.edit_fields.social.facebook = this.cafe.social.facebook;
      this.edit_fields.social.website = this.cafe.social.website;
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    countryBasedPhoneMask() {
      return this.$store.getters["worldwide/phoneMask"];
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style scoped>
.contact-row {
  display: flex;
  align-items: center;
}
</style>